module.exports = __webpack_public_path__ + "static/media/thermometer-quarter.1378dd22.svg";